export default "__VITE_ASSET__Ko92IHUq__"